import React from "react";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { HomeBanner } from "../components/HomeBanner";
import { HomeIntro } from "../components/HomeIntro";
import { MethodSteps } from "../components/MethodSteps";
import { Pricing } from "../components/Pricing";
import { RelightTeaser } from "../components/RelightTeaser";
import { ContactFooter } from "../components/ContactFooter";
import { Audience } from "../components/Audience";
import { Faq } from "../components/Faq";
import { AssistantWidget } from "../components/AssistantWidget";

export default function HomePage() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-cream">
      <Header />
      <main>
        <HomeBanner />
        <Hero />
        <HomeIntro />
        <MethodSteps teaser />
        <Audience />
        <RelightTeaser />
        <Pricing preview withCall />
        <Faq />
      </main>
      <ContactFooter clearWidget />
      <AssistantWidget />
    </div>
  );
}
